import {
  register,
  registerInputValidationRules,
} from '@storyboard-fm/storyboard-ui'

register()
registerInputValidationRules()
